import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Environment, EnvironmentService } from '@galaxy/core';
import { Observable } from 'rxjs';

@Injectable()
export class ActivationSettingsApiService {
  private host: string;
  private createUrl = `${this.notificationServicesHost}/nsInternalApi/v3/activationSettings/set/`;

  constructor(
    public http: HttpClient,
    private environmentService: EnvironmentService,
  ) {}
  setNotificationSettings(accountGroupId: string, productIds: string[], sendEmail: boolean): Observable<any> {
    return this.http.post(
      this.createUrl,
      { accountGroupId: accountGroupId, productIds: productIds, sendEmailFlag: sendEmail },
      { withCredentials: true },
    );
  }

  private get notificationServicesHost(): string {
    if (this.host) {
      return this.host;
    }
    switch (this.environmentService.getEnvironment()) {
      case Environment.LOCAL:
        this.host = 'http://localhost:8094';
        break;
      case Environment.DEMO:
        this.host = 'https://notification-dot-vbc-demo.appspot.com';
        break;
      case Environment.PROD:
        this.host = 'https://notification-dot-vbc-prod.appspot.com';
        break;
    }
    return this.host;
  }
}
